module.exports = ".fiscalia-logo-container {\n  padding-top: 6px !important;\n  padding-left: 20px !important; }\n\n.fiscalia-title {\n  color: #EEEEEE; }\n\nli a .notification-icon {\n  font-size: 24px !important; }\n\n.fiscalia-title h2 {\n  margin: 10px 0px 5px 0px; }\n\n.fiscalia-title h3 {\n  margin-top: 6px;\n  color: #a7a7a7; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/library/main/main.component.scss
// module id = ./src/app/library/main/main.component.scss
// module chunks = main